const ZIP_CODE_MAX_LENGTH = 5
const DIGITS_REGEXP = /[^0-9]/g

// Transform function for "Zip/Billing Code" which allowed only digits with max length 5
export const transformZipCode = (value: string) => value.replace(DIGITS_REGEXP, "").slice(0, ZIP_CODE_MAX_LENGTH)
